import { Component, OnInit, TemplateRef, viewChild } from '@angular/core';

import { inject } from '@angular/core';
import { MatBottomSheetContainer } from '@angular/material/bottom-sheet';
import { NewHangForm } from '@components/forms/hang/new-hang-form.component';
import { HangSheet } from '@components/forms/hang/sheet/hang-sheet.component';
import { InterestForm } from '@components/forms/interest-form/interest-form.component';
import { PuebloForm } from '@components/forms/pueblo-form/pueblo-form.component';
import { Login } from '@components/login/login.component';
import { PuebloSheet, PuebloSheets } from '@services/pueblo-sheets.service';
import { DisplayNameForm } from '../forms/display-name/display-name-form.component';

// To add a new sheet to this component, start with step 1 in
// services/pueblo-sheets.service.ts

// 3. Add the new dialog component to the imports array below, then add
//    the dialog to the template.
@Component({
  selector: 'pueblo-sheets',
  imports: [
    PuebloForm,
    DisplayNameForm,
    HangSheet,
    InterestForm,
    Login,
    NewHangForm,
  ],
  template: `
    <ng-template #puebloFormSheet let-data>
      <pueblo-form
        [pueblo]="data.pueblo"
        (puebloCreated)="data.puebloCreated?.()"
        (puebloUpdated)="data.puebloUpdated?.()"
      ></pueblo-form>
    </ng-template>

    <ng-template #interestFormSheet let-data>
      <interest-form (interestsAdded)="data.interestsAdded?.()"></interest-form>
    </ng-template>

    <ng-template #hangFormSheet let-data>
      <hang-sheet
        [hang]="data.hang"
        [timespan]="data.timespan"
        (created)="data.hangCreated?.()"
        (updated)="data.hangUpdated?.()"
        (cancel)="data.cancel?.()"
        (pendingHang)="data.pendingHang?.($event)"
        (viewChange)="data.viewChange?.($event)"
        (changesMade)="data.changesMade?.($event)"
      ></hang-sheet>
    </ng-template>

    <ng-template #newHangForm let-data>
      <new-hang-form
        [hang]="data.hang"
        (created)="data.created?.($event)"
        (canceled)="data.canceled?.()"
      ></new-hang-form>
    </ng-template>

    <ng-template #loginSheet let-data>
      <login
        [contextText]="data?.contextText"
        (loggedIn)="data?.loggedIn?.()"
      ></login>
    </ng-template>

    <ng-template #displayNameSheet let-data>
      <display-name-form
        (nameChosen)="data?.nameChosen?.($event)"
      ></display-name-form>
    </ng-template>
  `,
})
export class PuebloSheetsComponent implements OnInit {
  private readonly sheets = inject(PuebloSheets);

  // 4. Add a viewChild for the dialog component below.
  private readonly $puebloFormSheet =
    viewChild.required<TemplateRef<MatBottomSheetContainer>>('puebloFormSheet');

  private readonly $interestFormSheet =
    viewChild.required<TemplateRef<MatBottomSheetContainer>>(
      'interestFormSheet',
    );

  private readonly $hangFormSheet =
    viewChild.required<TemplateRef<MatBottomSheetContainer>>('hangFormSheet');

  private readonly $newHangForm =
    viewChild.required<TemplateRef<MatBottomSheetContainer>>('newHangForm');

  private readonly $loginSheet =
    viewChild.required<TemplateRef<MatBottomSheetContainer>>('loginSheet');

  private readonly $displayNameSheet =
    viewChild.required<TemplateRef<MatBottomSheetContainer>>(
      'displayNameSheet',
    );

  // 5. Register the dialog component with the PuebloSheets service. All done!
  ngOnInit() {
    this.sheets._register(PuebloSheet.PUEBLO_FORM, this.$puebloFormSheet());
    this.sheets._register(PuebloSheet.DISPLAY_NAME, this.$displayNameSheet());
    this.sheets._register(PuebloSheet.HANG_FORM, this.$hangFormSheet());
    this.sheets._register(PuebloSheet.NEW_HANG_FORM, this.$newHangForm());
    this.sheets._register(PuebloSheet.INTEREST_FORM, this.$interestFormSheet());
    this.sheets._register(PuebloSheet.LOGIN, this.$loginSheet());
  }
}
